import Nav from './components/Nav';
import Main from './components/Main';

const App = () => {
  return (
    <div className="">
      <Nav />
      <Main />
    </div>
  );
};

export default App;
